// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__24B61","header":"Messages_header__2PkDN"};